import { Button, Loader } from '@pocketlaw/tetris';
export function SubmitButton(props) {
    const { onClick, children, disabled, loading } = props;
    return (<Button type="button" $stretch appearance="primary" size="small" onClick={onClick} disabled={disabled || loading}>
      {children}
      {loading && <Loader />}
    </Button>);
}
